module.exports = {
  vapidPublicKey:
    "BKOuPUQhtIH9JZJHc63bH6mDNU0isvtzAqzPb-7bP8Byfqd-0IxX2f3yRmvwqml-9DvBYA6gKQvTKz9o3qkmXsU",
  baseUrl:
    process.env.NODE_ENV === "production"
      ? `https://orders.balkan1936.co.il/api`
      : `http://localhost:3031/api`,
  paymentCheckLink: "https://app.chex.co.il/terminal/511325573"    
};
